











import { Component, Prop, Provide, Vue } from "vue-property-decorator";

@Component
export default class bannerTop extends Vue {
	// private imgUrl: string = '../../../../static/images/banner.png';
	// private title: string = '5G基站智能质检';
	// private subTitle: string = '轻松创建您的专属机器人';

	// 接受父组件的值 
	@Prop({
		type: Object, // 父组件传递给子组件的数据类型
		required: false, // 是否必填
		default: ()=>({}) // 默认值default: ''， 如果传入的是 Object，则要 default: ()=>({}) 参数为函数
	})
	private bannerData!: object; // '!' 指不确定是否会传入这个参数  '?' 是指一定会给这个参数赋值
	created() {
		// console.log(this.bannerData)
	}

}
